<template>
  <div class="flex w-full justify-between">
    <button
      v-if="!isInFirstPage"
      @click="onClickPreviousPage"
    >
      <IconsActionsArrow class="rotate-90" />
    </button>

    <button
      v-for="page in pages"
      :key="page.name"
      :class="isPageActive(page.name) ? 'font-bold underline' : ''"
      class="text-blue"
      @click="onClickPage(page.name)"
    >
      {{ page.name }}
    </button>

    <button
      v-if="!isInLastPage"
      class="text-red-500"
      @click="onClickNextPage"
    >
      <IconsActionsArrow class="-rotate-90" />
    </button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  totalPages: {
    type: Number as () => number,
    required: true,
  },
  currentPage: {
    type: Number as () => number,
    required: true,
  },
});

const maxVisibleButtons = ref(3);

const pages = computed(() => {
  const range = [];
  const startPage = Math.max(1, props.currentPage - maxVisibleButtons.value);
  const endPage = Math.min(props.currentPage + maxVisibleButtons.value, props.totalPages);

  for (let i = startPage; i <= endPage; i++) {
    range.push({
      name: i,
      isDisabled: i === props.currentPage,
    });
  }

  return range;
});

const isInFirstPage = computed(() => {
  return props.currentPage === 1;
});

const isInLastPage = computed(() => {
  return props.currentPage === props.totalPages;
});

const emit = defineEmits(['update:currentPage']);

function onClickPreviousPage() {
  emit('update:currentPage', props.currentPage - 1);
}

function onClickPage(page: number) {
  emit('update:currentPage', page);
}

function onClickNextPage() {
  emit('update:currentPage', props.currentPage + 1);
}

function isPageActive(page: number) {
  return props.currentPage === page;
}

watch(() => props.totalPages, () => {
  maxVisibleButtons.value = 3;
});
</script>
